export default __webpack_public_path__ + "static/media/plus.794eb519.svg";